/**
 * Utility to get the correct API base URL based on the current hostname
 * This ensures cookies work properly by using the same domain for frontend and backend
 */
export const getApiBaseUrl = (): string => {

  console.log("**********console.log(process.env.REACT_APP_API_URL);*****************",process.env.REACT_APP_API_URL);


  if (typeof window === 'undefined') {
    return process.env.REACT_APP_API_URL || 'http://localhost:8080';
  }
  
  // Use environment variable if set
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  
  // Production: Use api.zogzila.com for Java backend
  // Development: Use localhost:8080
  return window.location.hostname === 'localhost'
    ? 'http://localhost:8080'
    : 'https://api.zogzila.com';
};

export const getWsBaseUrl = (): string => {
  if (typeof window === 'undefined') {
    return process.env.REACT_APP_WS_URL || 'http://localhost:8080';
  }
  
  // Use environment variable if set
  if (process.env.REACT_APP_WS_URL) {
    return process.env.REACT_APP_WS_URL;
  }
  
  // Production: Use api.zogzila.com for WebSocket connection
  // Development: Use localhost:8080
  return window.location.hostname === 'localhost'
    ? 'http://localhost:8080'
    : 'https://api.zogzila.com';
};

export const getPythonApiUrl = (): string => {
  if (typeof window === 'undefined') {
    return process.env.REACT_APP_PYTHON_API_URL || 'http://localhost:8000';
  }
  
  // Use environment variable if set
  if (process.env.REACT_APP_PYTHON_API_URL) {
    return process.env.REACT_APP_PYTHON_API_URL;
  }
  
  // Production: Use py.zogzila.com for Python backend
  // Development: Use localhost:8000
  return window.location.hostname === 'localhost'
    ? 'http://localhost:8000'
    : 'https://py.zogzila.com';
};

/**
 * Return URI sent to TrueLayer for payment authorization redirects.
 * Must match an entry in TrueLayer Console → your app → Redirect URIs (payments).
 * Set REACT_APP_TRUELAYER_PAYMENT_RETURN_URI to your canonical URL if users can hit
 * both www and non-www (Console requires each variant separately otherwise).
 */
export const getTrueLayerPaymentReturnUri = (): string => {
  const fromEnv = (process.env.REACT_APP_TRUELAYER_PAYMENT_RETURN_URI || '').trim();
  if (fromEnv) return fromEnv.replace(/\/$/, '');
  if (typeof window === 'undefined') return 'http://localhost:3000/truelayer-connect';
  return `${window.location.origin}/truelayer-connect`;
};

